<template>
    <div>
      <div v-show="error && error != ''" style="color:red; word-wrap:break-word; font-style: italic">{{ error }}</div>
      <article class="tile is-child box" v-if="userFullName.length">
        <article class="tile is-child box">
          <div class="columns">
            <div class="column">
              <div class="columns">
                <div class="column is-2">
                  氏名:
                </div>
                <div class="column">
                  <b>{{userFullName}}</b>
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  社員番号:
                </div>
                <div class="column">
                  <b>{{user.user_code}}</b>
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  入社日:
                </div>
                <div class="column">
                  <b>{{user.start_from}}</b>
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  採用形態:
                </div>
                <div class="column">
                  <b>{{user.contract_type}}</b>
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  Status:
                </div>
                <div class="column">
                  <span v-html="statusToLabel(timesheetData ? timesheetData.status : null)"></span>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="columns">
                <div class="column is-2">
                  会社名:
                </div>
                <div class="column">
                  <b> {{user.vti_group === 'VTI Japan' ? '株式会社VTIジャパン' : '株式会社VTIコーポレーション'}} </b>
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  報告年月:
                </div>
                <div class="column">
                  <b>{{currentMonth}}</b>
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  所定労働時間:
                </div>
                <div class="column">
                  <b>{{user.working_hour}}</b>
                </div>
              </div>
              <div class="columns">
                <div class="column is-2">
                  休憩時間:
                </div>
                <div class="column">
                  <b>{{user.break_time_format}}</b>
                </div>
              </div>
              <div class="columns" v-if="timesheetData">
                <div class="column is-2">
                  Admin's message:
                </div>
                <div class="column">
                  <b style="word-break: break-all;">{{ timesheetData.note }}</b>
                </div>
              </div>
            </div>
          </div>
        </article>
        <br>
        <div class="control is-pulled-left">
          <a class="button" @click="backHistory">
            <span class="icon is-small">
              <i class="fa fa-arrow-left"></i>
            </span>
            <span>Back</span>
          </a>
        </div>
        <br>
        <table class="table is-bordered">
          <thead>
            <tr>
              <th v-for="(header, index) in headers" :key="index">
                {{header}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in previewData" :key="index">
              <td>{{index}}</td>
              <td :class="{'is-off-work': weekendAndHoliday(item)}">{{item.day_in_week}}</td>
              <td :class="{'is-off-work': offWork(item)}">
                <template v-if="(!empty(item.is_substitute_dayoff) || (item.is_off_work && !empty(item.ot_time_start))) && isWorking(item)">
                  {{substituteTxt}}
                </template>
                <template v-else-if="!empty(item.type)">
                  <template v-if="item.type === dayOffType.SUBSTITUTE">
                    {{substituteDayOffTxt}}
                  </template>
                  <template v-else-if="item.type === dayOffType.HALF_DAY || isHalfWorking(item)">
                    {{halfDayOffTxt}}
                  </template>
                  <template v-else-if="item.type === dayOffType.NOT_ALLOWED">
                    {{absenceTxt}}
                  </template>
                  <template v-else-if="(!empty(item.is_off_work) || !empty(item.is_off_day)) && empty(item.ot_time_start)">
                    {{holidayTxt}}
                  </template>
                </template>
                <template v-else-if="weekDay(item.date.date) === 0 || weekDay(item.date.date) === 6">
                  {{holidayTxt}}
                </template>
              </td>
              <td>
                {{!empty(item.start_working_time) && isWorking(item) ? item.start_working_time : ''}}
              </td>
              <td>
                {{!empty(item.end_working_time) && isWorking(item) ? item.end_working_time : ''}}
              </td>
              <td>
                {{!empty(item.real_lunch_time) && isWorking(item) ? item.real_lunch_time_string : ''}}
              </td>
              <td>
                <template v-if="!empty(item.type) && item.type === dayOffType.SUBSTITUTE">
                  {{ isHalfWorking(item) ? 0.5 : 1 }}
                </template>
              </td>
              <td>
                <template v-if="!empty(item.working_out) && (item.type === dayOffType.ALLOWED || item.type === dayOffType.LAST_YEAR)">
                  {{ isHalfWorking(item) ? 0.5 : 1 }}
                </template>
              </td>
              <td>
                {{ !empty(item.working_out) && isWorking(item) ? item.working_out : ''}}
              </td>
              <td>
                <template v-if="!empty(item.working_out) && empty(item.is_off_work)">
                  <template v-if="item.type === dayOffType.NOT_ALLOWED">
                    {{1}}
                  </template>
                  <template v-else-if="item.type === dayOffType.HALF_DAY">
                    {{0.5}}
                  </template>
                </template>
              </td>
              <td>
                {{ !empty(item.over_time) && empty(item.is_off_work) ? item.over_time_string : ''}}
              </td>
              <td>
                {{ !empty(item.over_night_time) && empty(item.is_off_work) ? item.over_night_time_string : ''}}
              </td>
              <td>
                {{ !empty(item.over_time) && !empty(item.is_off_work) ? item.over_time_string : ''}}
              </td>
              <td>
                {{ !empty(item.over_night_time) && !empty(item.is_off_work) ? item.over_night_time_string : ''}}
              </td>
              <td :class="{'is-off-work': holidayOff(item)}">
                <template v-if="!empty(item.note)">
                  {{item.note}}
                </template>
                <template v-else-if="item.is_substitute_dayoff !== null && !empty(item.is_off_work) && !empty(item.ot_time_start) && isWorking(item)">
                  <template v-if="!empty(item.is_substitute_dayoff)">
                    {{holidayWorkSubstitute}}
                  </template>
                  <template v-else>
                    {{holidayWorkOT}}
                  </template>
                </template>
                <template v-else-if="!empty(item.type)">
                  <template v-if="allDayType[item.type]['is_off_day']">
                    {{allDayType[item.type]['type_name']}}
                  </template>
                  <template v-else-if="item.is_holiday">
                    {{allDayType[dayOffType.JAPAN_HOLIDAY]['type_name']}}
                  </template>
                </template>
              </td>
            </tr>
            <tr v-if="previewData" style="font-weight: bold; font-style:italic;">
              <td style="font-style: normal;">合計</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{total.break}}</td>
              <td>{{sumSubstitute}}</td>
              <td>{{sumAllowedDayOff}}</td>
              <td>{{total.totalWork}}</td>
              <td>{{sumNotAllowedDayOff}}</td>
              <td>{{total.totalOT}}</td>
              <td>{{total.totalNightOT}}</td>
              <td>{{total.totalHolidayOT}}</td>
              <td>{{total.totalHolidayNightOT}}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </article>
    </div>
</template>
<script>
import TimesheetService from './../../services/timesheetservice'
import Utilities from '../../services/ultilities'
import Global from '../../services/globalservice'
import Vue from 'vue'
import moment from 'moment'
import store from './../../store/index'
import { TIMESHEET_PAGE, TIMESHEET_STATUS } from 'vuex-store/mutation-types'
import LoadModal from '../../views/components/modals/LoadModal.vue'
import AlertModal from '../../views/components/modals/AlertModal'
import NoteModal from '../../views/components/modals/NoteModal'

export default {
  components: {
    moment
  },
  data () {
    return {
      previewData: null,
      error: null,
      substituteTxt: '休出',
      halfDayOffTxt: '半休',
      absenceTxt: '欠勤',
      holidayTxt: '休日',
      substituteDayOffTxt: '振休',
      holidayWorkOT: 'OT精算',
      holidayWorkSubstitute: '代休',
      headers: [],
      dayOffType: Global.DAY_OFF_TYPE,
      allDayType: null,
      total: {},
      dayInMonth: 0,
      user: {},
      currentMonth: null,
      timesheetData: {},
      openLoadModal: null,
      openAlertModal: null,
      noteModal: null
    }
  },

  created () {
    var self = this
    self.getPreviewTimesheet()
    self.getTimesheetStatus()
  },

  mounted () {
    store.commit(TIMESHEET_PAGE, true)
    let self = this
    this.$events.listen('submit-timesheet', self.submitTimesheet)
    this.$events.listen('approve-timesheet', self.approveTimesheet)
    this.$events.listen('reject-timesheet', self.showNoteModal)
    this.$events.listen('complete-message', message => self.rejectTimesheet(message))
  },

  beforeDestroy () {
    this.$events.remove('submit-timesheet')
    this.$events.remove('approve-timesheet')
    this.$events.remove('reject-timesheet')
    this.$events.remove('complete-message')
    store.commit(TIMESHEET_PAGE, false)
    store.commit(TIMESHEET_STATUS, null)
  },

  computed: {
    sumSubstitute () {
      let totalSubstitute = 0
      for (let i = 1; i <= this.dayInMonth; i++) {
        if (!this.empty(this.previewData[i].type) && this.previewData[i].type === this.dayOffType.SUBSTITUTE) {
          this.isHalfWorking(this.previewData[i]) ? totalSubstitute += 0.5 : totalSubstitute += 1
        }
      }
      return totalSubstitute
    },

    sumAllowedDayOff () {
      let totalDayOff = 0
      for (let i = 1; i <= this.dayInMonth; i++) {
        if (!this.empty(this.previewData[i].working_out) && (this.previewData[i].type === this.dayOffType.ALLOWED || this.previewData[i].type === this.dayOffType.LAST_YEAR)) {
          this.isHalfWorking(this.previewData[i]) ? totalDayOff += 0.5 : totalDayOff += 1
        }
      }
      return totalDayOff
    },

    sumNotAllowedDayOff () {
      let totalMukyu = 0
      for (let i = 1; i <= this.dayInMonth; i++) {
        if (this.empty(this.previewData[i].working_out) || !this.empty(this.previewData[i].is_off_work)) {
          continue
        }
        if (this.previewData[i].type === this.dayOffType.NOT_ALLOWED) {
          totalMukyu += 1
        } else if (this.previewData[i].type === this.dayOffType.HALF_DAY) {
          totalMukyu += 0.5
        }
      }
      return totalMukyu
    },

    userFullName () {
      return !this.user.first_name || !this.user.last_name ? '' : this.user.first_name + ' ' + this.user.last_name
    }
  },

  methods: {
    getPreviewTimesheet () {
      var self = this
      TimesheetService.getPreviewTimesheet(
        self.$route.params.id,
        self.$route.params.month,
        self.$route.params.year,
        function (response) {
          if (response.status === 'success') {
            self.previewData = response.data.data
            self.headers = response.data.header
            self.allDayType = response.data.allDayType
            self.total = response.data.total
            self.dayInMonth = response.data.dayInMonth
            self.user = response.data.user
            self.currentMonth = response.data.currentMonth
          } else {
            console.log(response)
          }
        },
        function (err) {
          self.error = err
        }
      )
    },

    getTimesheetStatus () {
      var self = this
      let timesheet = {
        user_id: self.$route.params.id,
        month: self.$route.params.month,
        year: self.$route.params.year
      }
      TimesheetService.getTimesheetStatusOfUser(timesheet, function (response) {
        if (response.status === 'success') {
          self.timesheetData = response.data
          store.commit(TIMESHEET_STATUS, response ? response.data : null)
        }
      }, function (err) {
        store.commit(TIMESHEET_STATUS, err)
        self.error = err.message
      })
    },

    submitTimesheet () {
      let self = this
      let timesheet = {
        user_id: self.$route.params.id,
        month: self.$route.params.month,
        year: self.$route.params.year
      }
      this.showLoad()
      this.showModal = false
      TimesheetService.submitTimesheet(timesheet, function () {
        self.hideLoad()
        self.showAlertModal('Submit timesheet successfully.', true)
      }, function (err) {
        self.hideLoad()
        self.showAlertModal(err.message)
      })
    },

    approveTimesheet () {
      let self = this
      let timesheet = {
        user_id: self.$route.params.id,
        month: self.$route.params.month,
        year: self.$route.params.year
      }
      this.showLoad()
      this.showModal = false
      TimesheetService.approveTimesheet(timesheet, function () {
        self.hideLoad()
        // Reload the page directly on success
        window.location.reload()
      }, function (err) {
        self.hideLoad()
        // Show the alert modal on error
        self.showAlertModal(err.message)
      })
    },

    rejectTimesheet (message) {
      let self = this
      let timesheet = {
        user_id: self.$route.params.id,
        month: self.$route.params.month,
        year: self.$route.params.year,
        note: message
      }
      this.showLoad()
      this.showModal = false
      TimesheetService.rejectTimesheet(timesheet, function () {
        self.hideLoad()
        self.showAlertModal('Reject timesheet successfully.', true)
      }, function (err) {
        self.hideLoad()
        self.showAlertModal(err.message)
      })
    },

    statusToLabel (value) {
      return value === null ? '<span class="tag is-info is-small" style="font-size:12px"><span class="icon is-small"><i class="fa fa-eye-slash fa-1"></i></span>&nbsp; 未提出</span>'
      : value === 1 ? '<span class="tag is-primary is-small" style="font-size:12px"><span class="icon is-small"><i class="fa fa-check fa-1"></i></span>&nbsp; 承認済み</span>'
      : value === 2 ? '<span class="tag is-danger is-small" style="font-size:12px"><span class="icon is-small"><i class="fa fa-ban fa-1"></i></span>&nbsp; Rejected</span>'
      : '<span class="tag is-warning is-small" style="font-size:12px"><span class="icon is-small"><i class="fa fa-spinner fa-pulse fa-1"></i></span>&nbsp; 承認待ち</span>'
    },

    isHalfWorking (value) {
      return !this.empty(value.working_out) && value.is_off_day === 1 && value.time_off !== Global.DAY_OFF_TIME.ALL_DAY.id
    },

    isWorking (value) {
      return !this.empty(value.working_out) && (value.type === Global.DAY_OFF_TYPE.WORKING || value.type === Global.DAY_OFF_TYPE.HALF_DAY || this.isHalfWorking(value))
    },

    empty (value) {
      return Utilities.empty(value)
    },

    weekDay (date) {
      var day = moment(date)
      return day.weekday()
    },

    offWork (value) {
      return !this.empty(value.is_off_day) || !this.empty(value.is_substitute_dayoff) || !this.empty(value.is_off_work) || this.isHalfWorking(value) || value.type === this.dayOffType.HALF_DAY
    },

    weekendAndHoliday (value) {
      return !this.empty(value.is_off_work)
    },

    holidayOff (value) {
      return !this.empty(value.is_holiday) && this.empty(value.ot_time_start)
    },

    backHistory () {
        window.history.back()
    },

    showLoad () {
      const LoadModalComponent = Vue.extend(LoadModal)
      var propsData = {
        visible: true
      }
      this.openLoadModal = new LoadModalComponent({
        el: document.createElement('div'),
        propsData
      })
    },

    hideLoad () {
      this.openLoadModal.deactive()
    },

    showAlertModal (message, reload = false) {
      var self = this
      const AlertModalComponent = Vue.extend(AlertModal)
      var propsData = {
        visible: true,
        message: message,
        title: 'Message',
        okText: 'OK',
        reload: reload,
        ok: function () {
          self.openAlertModal.$children[0].deactive()
        }
      }
      this.openAlertModal = new AlertModalComponent({
        el: document.createElement('div'),
        propsData
      })
    },

    showNoteModal () {
      var self = this
      const NoteModalComponent = Vue.extend(NoteModal)
      var propsData = {
        visible: true,
        title: "Admin's message",
        okText: 'OK',
        cancelText: 'Cancel',
        reload: false,
        cancel: function () {
          self.openNoteModal.$children[0].deactive()
        }
      }
      this.openNoteModal = new NoteModalComponent({
        el: document.createElement('div'),
        propsData
      })
    }
  }
}
</script>

<style scoped>
.is-off-work {
  color: #FF0000;
}
</style>



// WEBPACK FOOTER //
// PreviewTimesheet.vue?d5bb2d6e